import * as React from 'react';
import {PaletteMode} from '@mui/material';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import {ThemeProvider, createTheme} from '@mui/material/styles';
import {ArrowDownward} from '@mui/icons-material';
import AppAppBar from '../components/AppAppBar';
import Highlights from '../components/Highlights';
import Pricing from '../components/Pricing';
import Features from '../components/Features';
import FAQ from '../components/FAQ';
import Footer from '../components/Footer';
import getLPTheme from '../components/getLPTheme';
import Hero from '../components/Hero';
import {Fade, Zoom, Slide} from 'react-awesome-reveal';
import FlowchartComponent from '../components/FlowChart/FlowChart';
import {useEffect} from 'react';

// 擴展 Window 接口以包含 zzzpayment
declare global {
  interface Window {
    zzzpayment?: {
      init: (options: {platformId: string; baseUrl?: string}) => void;
      open: (options: {
        platformId?: string;
        amount: number | string;
        currency: string;
        showLoading?: (isLoading: boolean) => void;
        onSuccess?: (result: any) => void;
        onCancel?: () => void;
        onError?: (error: any) => void;
      }) => void;
    };
  }
}

export default function LandingPage() {
  const [mode, setMode] = React.useState<PaletteMode>('light');
  const LPtheme = createTheme(getLPTheme(mode));

  // 加載SDK
  useEffect(() => {
    // 檢查是否已加載SDK
    if (typeof window.zzzpayment === 'undefined') {
      const script = document.createElement('script');
      script.src = 'https://zusers.zzztech.com.tw/payment-sdk.js';
      script.async = true;
      script.onload = () => {
        if (window.zzzpayment) {
          window.zzzpayment.init({
            platformId: 'dbe66e89-2edc-55b5-9c6e-820110b08d5f',
            baseUrl: 'https://zusers.zzztech.com.tw/checkout',
          });
          console.log('Payment SDK loaded for donation');
        }
      };
      document.body.appendChild(script);
    }
  }, []);

  return (
    <ThemeProvider theme={LPtheme}>
      <CssBaseline />
      <AppAppBar />
      <Hero />
      <Box sx={{bgcolor: 'background.default'}}>
        {/* Hero Section Scroll Down Icon */}
        <Box sx={{textAlign: 'center', mt: 2}}>
          <ArrowDownward
            sx={{
              fontSize: 40,
              color: 'primary.main',
              animation: 'bounce 2s infinite',
            }}
          />
        </Box>

        {/* Features Section with Zoom Effect */}
        <FlowchartComponent />
        <Zoom>
          <Features />
        </Zoom>
        <Divider />

        {/* Highlights Section with Fade Effect */}
        <Fade>
          <Highlights />
        </Fade>
        <Divider />

        {/* Pricing Section with Zoom Effect */}
        <Zoom>
          <Pricing />
        </Zoom>
        <Divider />

        {/* FAQ Section with Slide Effect */}
        <Slide direction='up'>
          <FAQ />
        </Slide>
        <Divider />

        <Fade duration={2000}>
          <Footer />
        </Fade>
      </Box>

      {/* Custom Global Animation Keyframes */}
      <style>
        {`
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% {
              transform: translateY(0);
            }
            40% {
              transform: translateY(-10px);
            }
            60% {
              transform: translateY(-5px);
            }
          }
        `}
      </style>
    </ThemeProvider>
  );
}
